__turbopack_context__.v({
  "chevron": "imageWithText-module__XwL0qq__chevron",
  "image": "imageWithText-module__XwL0qq__image",
  "imageOverlay": "imageWithText-module__XwL0qq__imageOverlay",
  "imageSmall": "imageWithText-module__XwL0qq__imageSmall",
  "imageWithText": "imageWithText-module__XwL0qq__imageWithText",
  "textSection": "imageWithText-module__XwL0qq__textSection",
  "title": "imageWithText-module__XwL0qq__title",
});
